import React from "react";

// component
import { Spin } from "antd";

type SubmitButton2Props = {
  title: string;
  onSubmitHandler: () => void;
  loading?: boolean;
  icon?: React.ReactNode;
  className?: string;
  disabled?: boolean;
};

const SubmitButton2: React.FC<SubmitButton2Props> = ({
  title,
  onSubmitHandler,
  loading,
  icon,
  className,
  disabled,
}) => {
  return (
    <button
      onClick={onSubmitHandler}
      disabled={loading || disabled}
      className={`text-[14px] font-abel py-3 px-4 bg-[#ffffff] text-[#243677] rounded-md hover:bg-[#CDD8FE] hover:text-[#243677] hover:border-[#CDD8FE] w-full max-w-[170px] border-[#243677] border font-bold ${className}`}
    >
      {loading && <Spin />} {title}
    </button>
  );
};

export default SubmitButton2;
